module.exports = __webpack_public_path__ + "img/20210619_171057.801ac4e8.jpg";